module.exports = __webpack_public_path__ + "assets/img/third_pay_page_google_style.8068a80.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/third_pay_page_google_style.png
// module id = FTdV
// module chunks = 50